import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService, OptionsserviceService, LoansService, OperationsService } from '../../_services/index';
import { CustomerService, StorageService } from '../../_services/index';

@Component({
  selector: 'app-calendarcashflow',
  templateUrl: './calendarcashflow.component.html',
  styleUrls: ['./calendarcashflow.component.css']
})
export class CalendarcashflowComponent implements OnInit {
  @Input('payment_date') payment_date:any;
  loading : any;
  @Input('currentUser') currentUser:any;
  has_data = false;
  param = {
    'search_string':''
  }
  
  repayments:any;
  constructor(public operationsService: OperationsService, public storageService: StorageService) { 

    //this.currentUser = this.storageService.read<any>('currentUser');
  }
 
  ngOnInit() {
    //this.getDueRepayments();
    if(this.currentUser){
      this.getCashFlowPerDate();
    }
    
   }
   getCashFlowPerDate(){
     this.loading = true;
     this.operationsService.getCashFlowPerDate(this.currentUser.token,this.param, this.payment_date)
       .subscribe(result => {
         this.loading = false;
         this.has_data = result.has_data;
         this.repayments = result.message; 
       });
   }
}
